import { HeroFrontpage } from 'ui/components';

export const HeroFrontpageFeature: React.FC<Content.HeroFrontpage> = ({ content, settings }) => (
	<HeroFrontpage {...content?.properties} {...settings?.properties} />
);
